import React , {Fragment} from 'react';
import { Field, reduxForm } from 'redux-form';
import {simpleInputField} from "../components/InputRenderers";
import LoadingIcon from '../../img/three-dots.svg';

const validate = (values) => {
    const errors = {};
    if (!values.userName || values.userName === '') {
        errors.userName = "لطفا نام کاربری را وارد کنید" ;
    }
    if (!values.email || values.email === '') {
        errors.email = "لطفا ایمیل را وارد کنید" ;
    }
    if (!values.fullName || values.fullName === '') {
        errors.fullName = "لطفا نام را وارد کنید" ;
    }
    return errors;
};


let AddOrEditOperatorForm = props => {
    const { handleSubmit, error, loading , bookCategories, isAdd} = props;
    return (
        <Fragment>
            <div className="sizeHandler_1185">
                <div className="addBookForm">
                    <div className="formContainer">
                        <Field name="userName" component={simpleInputField} label="نام کاربری" />
                        {isAdd ? <Field name="password" component={simpleInputField} label="رمز عبور" type="password" /> : null}
                        <Field name="email" component={simpleInputField} label="ایمیل" />
                        <Field name="fullName" component={simpleInputField} label="نام"/>
                    </div>
                </div>
            </div>

            <div className="maximumSizeHandler">
                <div className="confirmAll organizer">
                    <span className="lineSeparator"></span>
                    <div className="organizer centerText">
                        <div className="confirmationButton clickShape" onClick={handleSubmit}>
                            <span className="buttonText rightFloat">{isAdd ? `تایید` : `به روز رسانی`}</span>
                            {loading? <img src={LoadingIcon}/> :<span className="icon icon-check leftFloat"></span>}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};


const AddOrEditOperator = reduxForm({
    // a unique name for the form
    enableReinitialize: true ,
    form: "AddOrEditOperator",
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
})(AddOrEditOperatorForm);

export default AddOrEditOperator;